import { createGlobalStyle } from "styled-components";

export const GlobalDisableCopyPaste = createGlobalStyle`
    [data-disable-copy-paste] {
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }
`;
